// A setting with two states: its name at the left, a switch at the right.
// The whole row is the button. The owner draws the state from the store.

import { el } from '../lib/dom';

export type SettingSwitch = {
  root: HTMLButtonElement;
  draw: (on: boolean) => void;
};

export const createSettingSwitch = (
  label: string,
  onChange: (on: boolean) => void,
): SettingSwitch => {
  const root: HTMLButtonElement = el(
    'button',
    {
      className: 'switch',
      type: 'button',
      role: 'switch',
      ariaChecked: 'false',
      onclick: () => onChange(root.ariaChecked !== 'true'),
    },
    [
      el('span', { className: 'setting__label', textContent: label }),
      el('span', { className: 'switch__track' }, [el('span', { className: 'switch__thumb' })]),
    ],
  );

  return {
    root,
    draw: (on) => {
      root.ariaChecked = String(on);
    },
  };
};
